import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@achra/ui/skeleton';

/**
 * Skeleton for mobile navigation dropdown
 */
function MobileNavSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="h-9 w-37.5 xl:hidden"><Skeleton className="h-9 w-37.5" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
MobileNavSkeleton.displayName = 'MobileNavSkeleton';
export { MobileNavSkeleton };